// RUNN — region → regulatory framework mapping.
// Drives consent defaults and the legal copy shown to each visitor.
// Target launch regions: US · CA · EU · UK · IN · AU · UAE (16+ everywhere).

export const APP_MIN_AGE = 16;

// model: 'opt-in'  → non-essential OFF until the user actively agrees (strictest)
//        'opt-out' → allowed by default, user can opt out (US baseline)
// We render an opt-in experience everywhere; `model` only tweaks copy + defaults.
const FRAMEWORKS = {
  EU:      { label: 'GDPR', model: 'opt-in',  cookieConsent: true,  dataSale: false },
  GB:      { label: 'UK GDPR + PECR', model: 'opt-in', cookieConsent: true, dataSale: false },
  CA:      { label: 'PIPEDA · CASL · Quebec Law 25', model: 'opt-in', cookieConsent: true, dataSale: false },
  US:      { label: 'CCPA / CPRA + US state laws', model: 'opt-out', cookieConsent: false, dataSale: true },
  IN:      { label: 'DPDP Act 2023', model: 'opt-in', cookieConsent: true, dataSale: false },
  AU:      { label: 'Privacy Act 1988 (APPs)', model: 'opt-in', cookieConsent: true, dataSale: false },
  AE:      { label: 'UAE PDPL (Decree-Law 45/2021)', model: 'opt-in', cookieConsent: true, dataSale: false },
  DEFAULT: { label: 'Global baseline (GDPR-grade)', model: 'opt-in', cookieConsent: true, dataSale: false },
};

const EU_EEA = new Set([
  'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT',
  'LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','IS','LI','NO',
]);

/** Best-effort ISO country code from the browser locale. Null if unknown. */
export function detectRegionCode() {
  try {
    const loc = navigator.language || 'en-US';
    let reg = null;
    if (window.Intl && Intl.Locale) {
      try { reg = new Intl.Locale(loc).maximize().region; } catch { /* noop */ }
    }
    if (!reg) reg = (loc.split('-')[1] || '').toUpperCase();
    return reg ? reg.toUpperCase() : null;
  } catch {
    return null;
  }
}

export function frameworkFor(regionCode) {
  if (!regionCode) return { region: 'DEFAULT', ...FRAMEWORKS.DEFAULT };
  const rc = regionCode.toUpperCase();
  if (EU_EEA.has(rc)) return { region: rc, ...FRAMEWORKS.EU };
  if (FRAMEWORKS[rc]) return { region: rc, ...FRAMEWORKS[rc] };
  return { region: rc, ...FRAMEWORKS.DEFAULT };
}

/** The framework descriptor for the current visitor. */
export function currentFramework() {
  return frameworkFor(detectRegionCode());
}
